// @spotify/backstage-plugin-soundcheck doesn't export its rootRouteRef.
// Without it registered on the PageBlueprint, useRouteRef(rootRouteRef) inside
// SoundcheckHeaderBUI returns undefined, which hides the "Get Started" button.
// If that button is removed or replaced, this workaround can be deleted.
import { createElement } from 'react';
import { getComponentData, type RouteRef } from '@backstage/core-plugin-api';
import { SoundcheckRoutingPage } from '@spotify/backstage-plugin-soundcheck';

export const soundcheckRouteRef = getComponentData<RouteRef>(
  createElement(SoundcheckRoutingPage),
  'core.mountPoint',
)!;
